/**
* plugins/vuetify.js
*
* Framework documentation: https://vuetifyjs.com`
*/

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Default Theme Configuration
const defaultTheme = {
  dark: false, // Set to true if you want a dark theme by default
  // SYN-2738 (A9): o Vuetify escreve texto branco sobre estas cores (v-btn,
  // v-chip, v-alert). Os tons antigos reprovavam AA com branco (primary 4.23,
  // secondary 3.68, error 3.68, info 3.12, success 2.78, warning 2.20:1); estes
  // são os mesmos matizes um degrau mais escuros, todos ≥4.5:1 com branco.
  colors: {
    primary: '#D32F2F', // Forebrain Red (was #E53935) — 4.98:1
    secondary: '#1976D2', // Blue (was #1E88E5) — 4.60:1
    accent: '#FFC107', // Example Amber (texto preto do Vuetify, 12.9:1)
    error: '#D32F2F', // was #f44336 — 4.98:1
    info: '#1976D2', // was #2196F3 — 4.60:1
    success: '#2E7D32', // was #4CAF50 — 5.13:1
    warning: '#B45309', // was #FB8C00 — 5.02:1
    background: '#FFFFFF', // Ensure light background
    surface: '#FFFFFF',
  },
  variables: {
    'font-family': '"Noto Sans", sans-serif',
    'body-font-family': '"Noto Sans", sans-serif',
    'heading-font-family': '"Noto Sans", sans-serif',
    // 'font-size-root': '16px', // Default is 16px
    // 'line-height-root': '1.5', // Default line height
    // Adjust other variables like border-radius, spacing etc. if needed
    // 'rounded-xl': '16px',
  }
};


// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'light', // Set the default theme name
        themes: {
            light: defaultTheme, // Assign the configuration object
            // Define a dark theme configuration if needed
            // dark: { ... }
        },
    },
    // Optional: Set default props for components globally
    // defaults: {
    //   VBtn: {
    //     // Example: Make all buttons slightly rounded by default
    //     // rounded: 'sm',
    //   },
    //   VTextField: {
    //     // Example: Set default variant for text fields
    //     // variant: 'outlined',
    //     // density: 'compact',
    //   }
    // }
})